/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LanguageToEmailTemplatesInner } from './';
import {
    LanguageToEmailTemplatesInnerFromJSON,
    LanguageToEmailTemplatesInnerFromJSONTyped,
    LanguageToEmailTemplatesInnerToJSON,
} from './';
import type { ReasonForRefusal } from './';
import {
    ReasonForRefusalFromJSON,
    ReasonForRefusalFromJSONTyped,
    ReasonForRefusalToJSON,
} from './';

/**
 * 
 * @export
 * @interface StrategyRefusalReasonsInner
 */
export interface StrategyRefusalReasonsInner {
    /**
     * 
     * @type {ReasonForRefusal}
     * @memberof StrategyRefusalReasonsInner
     */
    reasonForRefusal: ReasonForRefusal;
    /**
     * 
     * @type {Array<LanguageToEmailTemplatesInner>}
     * @memberof StrategyRefusalReasonsInner
     */
    languageToEmailTemplates: Array<LanguageToEmailTemplatesInner>;
}

/**
 * Check if a given object implements the StrategyRefusalReasonsInner interface.
 */
export function instanceOfStrategyRefusalReasonsInner(value: object): value is StrategyRefusalReasonsInner {
    if (!('reasonForRefusal' in value) || value['reasonForRefusal'] === undefined) return false;
    if (!('languageToEmailTemplates' in value) || value['languageToEmailTemplates'] === undefined) return false;
    return true;
}

export function StrategyRefusalReasonsInnerFromJSON(json: any): StrategyRefusalReasonsInner {
    return StrategyRefusalReasonsInnerFromJSONTyped(json, false);
}

export function StrategyRefusalReasonsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): StrategyRefusalReasonsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'reasonForRefusal': ReasonForRefusalFromJSON(json['reasonForRefusal']),
        'languageToEmailTemplates': ((json['languageToEmailTemplates'] as Array<any>).map(LanguageToEmailTemplatesInnerFromJSON)),
    };
}

export function StrategyRefusalReasonsInnerToJSON(value?: StrategyRefusalReasonsInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reasonForRefusal': ReasonForRefusalToJSON(value['reasonForRefusal']),
        'languageToEmailTemplates': ((value['languageToEmailTemplates'] as Array<any>).map((v) => LanguageToEmailTemplatesInnerToJSON(v))),
    };
}

